import React from 'react';
import { HowToPlayModal } from '../../components/HowToPlayModal/HowToPlayModal';
import { LETTER_HIVE_MIN_LENGTH, LETTER_HIVE_PANGRAM_BONUS } from './letterHiveUtils';

export function HowToPlay({ onClose }) {
  return (
    <HowToPlayModal title="How to Play" titleId="letter-hive-how-title" onClose={onClose}>
      <p className="how-to-play-intro">
        Use the seven letters. Each word must be at least <strong>{LETTER_HIVE_MIN_LENGTH} letters</strong>,
        include the center letter, and use only hive letters.
      </p>
      <p className="how-to-play-intro">
        Scoring: 4-letter words = 1 point; longer words score their length. A pangram uses all seven letters
        at least once and earns <strong>+{LETTER_HIVE_PANGRAM_BONUS} bonus points</strong>.
      </p>
      <p className="how-to-play-intro">
        Daily uses the same hive for everyone (local calendar day). Practice picks a random hive.
      </p>
    </HowToPlayModal>
  );
}
